import React, { useEffect } from 'react';
import { ResizablePanelGroup, ResizableHandle, ResizablePanel } from "@/components/ui/resizable";
import { Outlet } from "react-router-dom";
import ListingConsultant from '@/components/organisms/navigation/MenuConsultant/ListingConsultant';
import { SelectedItemsProvider, useSelectedItems } from "@/context/SelectedItemsContext";
import { Label } from '@/components/atoms/texts/label';
import { Button } from '@/components/molecules/buttons/button';
import { Separator } from '@/components/atoms/divider/separatorShadcn';

// Hooks for overlay
import { useGenerateFiduciaryReport } from '@/services/admin-services/api-rest/useGenerateFiduciaryReport';
import MailOutlineIcon from '@mui/icons-material/MailOutline';

// Icons
import RequestQuoteRoundedIcon from '@mui/icons-material/RequestQuoteRounded';
import { ClearRounded } from '@mui/icons-material';
import { useToast } from '@/components/organisms/feedback/use-toast';
import { ToastAction } from '@/components/organisms/feedback/toast';
import { useSendFiduciaryReportByMail } from '@/services/admin-services/mutations/useSendFiduciaryReportByMail';

export default function Consultant() {
    return (
        <SelectedItemsProvider>
            <div className="bg-lighter flex flex-col grow relative overflow-hidden">
                <ResizablePanelGroup direction="horizontal" className={"divide-x "} id="panel1" order={1}>
                    <ResizablePanel defaultSize={15} className=' h-full px-firstDegree bg-medium max-w-[260px] w-[260px] min-w-[260px] z-20' id="panelListing" order={1} >
                        <ListingConsultant />
                    </ResizablePanel>
                    {/* <ResizableHandle withHandle /> */}
                    <Outlet />
                </ResizablePanelGroup>
                {/* Overlay affichant le nombre d'éléments sélectionnés */}
                <Overlay />
            </div>
        </SelectedItemsProvider>
    );
}

// Fonction utilitaire pour vérifier les types des éléments sélectionnés
function shouldShowButton(selectedItems, allowedTypes) {
    if (!selectedItems || selectedItems.length === 0) return false;
    return selectedItems.every(item => allowedTypes.includes(item.type));
}

function Overlay() {
    const { selectedItems, setSelectedItems } = useSelectedItems();
    const { toast } = useToast();

    const { generateFiduciaryReport, loading: loadingFiduciaryReport, error: errorFiduciaryReport, data: dataFiduciaryReport } = useGenerateFiduciaryReport();
    const { sendFiduciaryReportByMail, loading: loadingSendMail, error: errorSendMail, data: dataSendMail } = useSendFiduciaryReportByMail();

    const handleGenerateFiduciaryReport = async () => {
        const selectedUuids = selectedItems?.map(item => item.uuid); // Récupère les UUIDs des éléments sélectionnés
        console.log("generateFiduciaryReport", selectedUuids);
        if (selectedUuids?.length > 0) {
            const result = await generateFiduciaryReport(selectedUuids); // Envoi des UUIDs sous forme de tableau
            if (result?.url) {
                // const link = document.createElement("a");
                // link.href = result.url;
                // link.download = "FiduciaryReport.xlsx";
                // document.body.appendChild(link);
                // link.click();
                // document.body.removeChild(link);
                // setSelectedItems(prevItems =>
                //     prevItems.filter(item => !selectedUuids.includes(item.uuid))
                // );
            }
        }
    };

    const handleSendFiduciaryReportByMail = async () => {
        const selectedUuids = selectedItems?.map(item => item.uuid);
        console.log("sendFiduciaryReportByMail", selectedUuids);
        if (selectedUuids?.length > 0) {
            const result = await sendFiduciaryReportByMail(selectedUuids);
            if (result) {
                toast({
                    variant: "success",
                    title: "success.mailSent",
                    duration: 8000,
                    description: "success.fiduciaryReportSentByMail"
                });
            }
        }
    };

    const clearSelection = () => {
        setSelectedItems([]); // Vide la liste des éléments sélectionnés
    };

    // Définir les types autorisés pour le bouton Fiduciary Report
    const allowedTypesForFiduciaryReport = ["EXPENSE"];
    const showFiduciaryReportButton = shouldShowButton(selectedItems, allowedTypesForFiduciaryReport);

    // Ajouter ici d'autres conditions pour afficher de nouveaux boutons
    // Exemple :
    // const allowedTypesForAnotherButton = ["TIMESHEET"];
    // const showAnotherButton = shouldShowButton(selectedItems, allowedTypesForAnotherButton);

 // Définir les types autorisés pour le bouton d'envoi par mail
    const allowedTypesForSendMail = ["EXPENSE"];
    const showSendMailButton = shouldShowButton(selectedItems, allowedTypesForSendMail);

    useEffect(() => {
        // dataFiduciaryReport && window.open(dataFiduciaryReport?.url, "_blank")// Ouvrir l'URL dans un nouvel onglet
        if (dataFiduciaryReport?.url && selectedItems?.length > 0) {
            const selectedUuids = selectedItems?.map(item => item.uuid); // Récupère les UUIDs des éléments sélectionnés
            toast({
                variant: "success",
                title: "success.fileGenerated",
                duration: 8000,
                description: "success.ifNotDownload",

                action: (
                    <ToastAction
                        altText="Si le fichier ne se télécharge pas, cliquez sur Télécharger"
                        onClick={() => {
                            const link = document.createElement("a");
                            link.href = dataFiduciaryReport?.url;
                            link.download = "FiduciaryReport.xlsx";
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                        }}
                    >
                        <Label message="global.actions.download" />
                    </ToastAction>
                ),
            });
            const link = document.createElement("a");
            link.href = dataFiduciaryReport.url;
            link.download = "FiduciaryReport.xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setSelectedItems(prevItems =>
                prevItems.filter(item => !selectedUuids.includes(item.uuid))
            );
        }
    }, [dataFiduciaryReport]);
    useEffect(() => {
        const displayToast = () => {
            toast({
                variant: "error",
                title: "error.requestFailed",
                duration: 8000,
                description: errorFiduciaryReport?.message
            })
        }
        errorFiduciaryReport && !loadingFiduciaryReport && displayToast();
    }, [errorFiduciaryReport]);
    useEffect(() => {
        if (errorSendMail && !loadingSendMail) {
            toast({
                variant: "error",
                title: "error.mailSendFailed",
                duration: 8000,
                description: errorSendMail?.message,

            });
        }
    }, [errorSendMail]);

    if (selectedItems?.length > 0) return (
        <div className="bg-information px-secondDegree text-center whitespace-nowrap max-w-[98%] absolute bottom-2 left-1/2 transform -translate-x-1/2 p-2 rounded-sm shadow-md text-white flex justify-center items-center gap-firstDegree h-12 hover:shadow-lg z-50">
            <ClearRounded fontSize="small" onClick={clearSelection} className="cursor-pointer" />
            <span><Label>{selectedItems?.length}</Label> <Label message="global.itemsSelected" /></span>
            <Separator orientation="vertical" />
            {/* Si aucune action n'est disponible pour la sélection */}
            {(!showFiduciaryReportButton && !showSendMailButton /* Ajouter ici d'autres conditions similaires pour d'autres boutons */) && (
                <span><Label className="text-grey" message="error.noActionAvailableForSelection"></Label></span>
            )}
            {showFiduciaryReportButton && (
                loadingFiduciaryReport ? (
                    <span className="loader" />
                ) : (
                    <Button
                        leftIcon={<RequestQuoteRoundedIcon />}
                        showLeftIcon
                        showText={false}
                        style="ghost"
                        sizePadding="small"
                        showToolTip
                        className="text-white"
                        text="consultants.expense.downloadfiduciaryReport"
                        onClick={handleGenerateFiduciaryReport}
                    />
                )
            )}
            {showSendMailButton && (
                loadingSendMail ? (
                    <span className="loader" />
                ) : (
                    <Button
                        leftIcon={<MailOutlineIcon />}
                        showLeftIcon
                        showText={false}
                        style="ghost"
                        sizePadding="small"
                        showToolTip
                        className="text-white"
                        text="consultants.expense.sendFiduciaryReportByMail"
                        onClick={handleSendFiduciaryReportByMail}
                    />
                )
            )}
            {/* Ajouter ici d'autres boutons avec leurs conditions */}
            {/* Exemple :
            {showAnotherButton && (
                <Button
                    leftIcon={<SomeOtherIcon />}
                    showLeftIcon
                    showText={false}
                    style="ghost"
                    sizePadding="small"
                    showToolTip
                    className="text-white"
                    text="some.other.action"
                    onClick={handleAnotherAction}
                />
            )}

            {/* Ajouter ici d'autres boutons avec leurs conditions */}
        </div>
    );
}
